import React from "react";
import { InboxOutlined } from "@ant-design/icons";
import {
  DRAGGER_SCANNING_TEXT,
  DRAGGER_TEXT,
  DRAGGER_HINT,
} from "constants/viewSourcesDrawer.constants";

const DraggerContent = ({ safetyScanning }) => (
  <>
    <p className="ant-upload-drag-icon">
      <InboxOutlined />
    </p>
    {safetyScanning ? (
      <p className="ant-upload-text">{DRAGGER_SCANNING_TEXT}</p>
    ) : (
      <>
        <p className="ant-upload-text">{DRAGGER_TEXT}</p>
        <p className="ant-upload-hint">{DRAGGER_HINT}</p>
      </>
    )}
  </>
);

export default DraggerContent;
